import {ModuleController} from "../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../infrastructure/domain-services/base-managed-service";
import {RelatedEntitiesWidgetConfig} from "./related-entities-widget.config";
import {RelatedEntitiesWidgetStore} from "./related-entities-widget.store";
import {RelatedEntitiesWidgetHandlers} from "./handlers/related-entities-widget.handlers";

export class RelatedEntitiesWidgetController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, RelatedEntitiesWidgetConfig, RelatedEntitiesWidgetStore, RelatedEntitiesWidgetHandlers];
}
